import { createContext } from "react";

export const JournalContext = createContext({});
